import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const BulletLine = styled.div`
  width: 21px;
  height: 2.5px;
  background-color: #ffba5c;
  margin-right: 10px;
`;

const BulletWrapper = ({ className, children }) => {
  return (
    <Wrapper>
      <BulletLine />
      <div className={className || ""}>{children}</div>
    </Wrapper>
  );
};

export default BulletWrapper;
